import React from 'react';
import { noop, createField } from '../helpers';
import {CheckboxFieldRenderer} from '../field-renderers';

const CheckboxField = createField<boolean, HTMLInputElement, {}>(({
    name = null,
    className,
    value = false,
    onValueChange = noop,
    Renderer, error, label, onValueReset, onValueSubmit,
    ...props
}) => <input type="checkbox"
    className={`${className}`}
    name={name}
    checked={value}
    onChange={(e) => onValueChange(e.currentTarget.checked, value, name, e)}
    {...props}
/>, CheckboxFieldRenderer);

export default CheckboxField;
